/**************
// Закрывать popver по клику за его пределы.
$(document).click(function (e)
{
  //alert("tt");
  // check the parents to see if we are inside of a tool tip.  If the click came
  // from outside the tooltip, then hide our tooltip
  if ($(e.target).parents('.popover').length == 0 && !$(e.target).is("[data-original-title]"))
  {
  	//alert("!");
  	$('[data-original-title]').popover('hide');
  }
});

/*****/

$('body').on('hidden.bs.modal', function() {
	if($("body > .modal > .modal-dialog.show").length)
	{
		$('body').addClass('modal-open');
	}
});
